<template>
  <VTextField
    v-model="emailInput"
    class="ns-email flex-column"
    :class="$style['ns-email-simple']"
    name="email"
    :maxlength="maxLength"
    :label="label"
    :disabled="disabled"
    :rules="emailRules"
    validate-on-blur
  />
</template>

<script>
import { VTextField } from 'vuetify/lib';

export default {
  name: 'NsEmailSimple',
  components: {
    VTextField,
  },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * This is the Label of the input component.
     * Example: "Email Address:"
     * For local translations of this for a variety of locales, see:
     * https://nuskin.atlassian.net/wiki/spaces/SLE/pages/379682861/Standard+Email+Component+Translations
     */
    label: {
      type: String,
      required: true,
    },
    /**
     * This is the error message for the input component. It will not
     * actually be displayed unless the error state is reached.
     * Example: "Invalid e-mail"
     * For local translations, see the link above.
     */
    invalidEmailText: {
      type: String,
      required: true,
    },
    /**
     * This is the error message for the input component. It will not
     * actually be displayed unless the error state is reached.
     * Example: "Duplicate e-mail found"
     * For local translations, see the link above.
     */
    dupedEmailText: {
      type: String,
      required: false,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    requiredErrorMessage: {
      type: String,
      default: '',
    },
    isEmailAvailable: {
      type: Boolean,
      default: true,
    },
    isServiceValid: {
      type: Boolean,
      default: true,
    },
    checkEmail: {
      type: Function,
      default: undefined,
    },
    maxLength: {
      type: Number,
      default: 241,
    },
  },
  data() {
    return {
      emailInput: '',
      isPatternVaild: true,
      emailPattern: /^[\s]*[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+(?:\.[A-Za-z0-9!#$%&*+/=?^_`{|}~-]+)*@(?:[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?\.)+[A-Za-z0-9](?:[A-Za-z0-9-]*[A-Za-z0-9])?[\s]*$/,
    };
  },
  computed: {
    emailRules() {
      return [
        ...(this.required
          ? [
              () => {
                return Boolean(this.emailInput) || this.requiredErrorMessage;
              },
            ]
          : []),
        this.isEmailAvailable ? true : this.dupedEmailText,
        this.isPatternVaild ? true : this.invalidEmailText,
        this.isEmailValid ? true : this.invalidEmailText,
      ];
    },
    isEmailValid() {
      return (
        this.isPatternVaild && this.isServiceValid && this.isEmailAvailable
      );
    },
  },
  watch: {
    emailInput(val) {
      this.emailInput = this.emailInput.toLowerCase().trim();
      this.$emit('input', this.emailInput);
      if (this.emailPattern.test(val)) {
        this.isPatternVaild = true;
        this.$emit('check', this.emailInput);
      } else {
        this.isPatternVaild = false;
      }

      if (this.checkEmail) {
        this.debounceEmail(() => this.checkEmailFunc());
      }
    },
  },
  methods: {
    debounceEmail(func, timeout = 300) {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        func();
      }, timeout);
    },
    checkEmailFunc() {
      this.checkEmail().then((result) => {
        const [isServiceValid, isEmailAvailable] = result;
        this.isServiceValid = isServiceValid;
        this.isEmailAvailable = isEmailAvailable;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.ns-email {
  // font-family: map.get(typographyVariables.$typography, font-family-primary);
  position: relative;
}
.theme--light.v-input:not(.v-input--is-disabled) input {
  border: 1px solid map.get(colors.$theme, 'primary');
}
</style>
<style lang="scss" module>
@use "sass:map";
@use "~@nuskin/ns-core-styles/src/scss/colors";

.ns-email-simple {
  input[type='text']:focus {
    border: 1px solid map.get(colors.$theme, $key: 'accent-color-b') !important;
  }
}
</style>
